import { DataTable } from "../../components/DataTable";
import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Row = {
  id: string;
  matterId: string;
  formKind: string;
  deadlineKind: string;
  deadlineDate: string;
  status: string;
};

export default function DeadlinesPage() {
  const { t } = useIntl();
  const { data, loading, error } = useFetch<{ deadlines: Row[] }>("/api/v1/tenant/deadlines");
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("deadlines.title")}</h1>
      <DataTable
        rows={data?.deadlines ?? null}
        loading={loading}
        error={error}
        empty={t("deadlines.empty")}
        columns={[
          { header: t("deadlines.col.matter"), render: (r) => r.matterId },
          { header: t("deadlines.col.form"), render: (r) => r.formKind },
          { header: t("deadlines.col.kind"), render: (r) => r.deadlineKind },
          {
            header: t("deadlines.col.date"),
            render: (r) => new Date(r.deadlineDate).toLocaleDateString(),
          },
          { header: t("deadlines.col.status"), render: (r) => r.status },
        ]}
      />
    </div>
  );
}
